type SVGType = {
  name?:
    | 'logo' // 0 0 46 22
    | 'mega-menu' // 0 0 24 24
    | 'mega-close' // 0 0 24 24
    | string;
  className?: string;
  xmlns?: string;
  width?: number;
  height?: number;
  viewBox?: string;
  version?: string;
  style?: React.CSSProperties;
  fill?: string;
};
export default function SVG({
  name,
  className = '',
  xmlns = 'http://www.w3.org/2000/svg',
  width = 28,
  height = 28,
  viewBox = '0 0 28 28',
  version = '1.1',
  style,
  fill,
}: SVGType) {
  let data = null;
  switch (name) {
    case 'logo':
      data = (
        <>
          <path
            d="M32.196 19.9107L27.382 15.155C27.7892 14.26 28.1361 13.339 28.4205 12.3981H31.3468C31.3792 12.3981 31.4103 12.3853 31.4333 12.3625C31.4562 12.3397 31.4691 12.3087 31.4691 12.2764V9.74924C31.4691 9.71674 31.4563 9.68552 31.4334 9.66232C31.4105 9.63912 31.3794 9.62578 31.3468 9.62518H26.385C26.3573 9.62539 26.3305 9.63476 26.3088 9.65182C26.2871 9.66887 26.2717 9.69264 26.265 9.71938C26.0006 10.8526 25.663 11.9676 25.2542 13.0575L21.9402 9.7837C22.501 9.41841 23.3687 8.92677 23.9826 8.22606C24.455 7.68196 24.7993 7.03959 24.9902 6.34597C25.181 5.65235 25.2138 4.92502 25.0859 4.2172C24.958 3.50937 24.6728 2.83895 24.2511 2.255C23.8294 1.67106 23.2819 1.18835 22.6487 0.842192C21.7116 0.310904 20.6258 0.0992218 19.5566 0.239417C18.4875 0.379612 17.4937 0.863993 16.7268 1.61872L16.6899 1.65547C16.0244 2.31052 15.5621 3.14231 15.3583 4.05166C15.2119 4.77494 15.2298 5.52167 15.4106 6.23719C15.5915 6.9527 15.9308 7.61889 16.4038 8.187C16.7407 8.57296 17.0707 8.9038 17.4169 9.23463C16.8057 9.61193 16.2185 10.0262 15.6583 10.4752C13.0574 12.7244 12.6928 16.375 14.8091 18.9756C15.3794 19.673 16.0992 20.2345 16.9159 20.6189C17.7325 21.0033 18.6252 21.2009 19.5285 21.1972C21.2778 21.1972 23.8118 20.5746 25.9419 17.6615L28.3074 19.998C28.3825 20.0716 28.4836 20.1128 28.589 20.1128H32.1107C32.1323 20.1131 32.1536 20.1069 32.1717 20.095C32.1898 20.0832 32.2039 20.0662 32.2122 20.0462C32.2252 20.0251 32.2307 20.0003 32.2277 19.9757C32.2248 19.9511 32.2136 19.9282 32.196 19.9107V19.9107ZM22.3371 4.6467C22.3924 4.95835 22.3798 5.27818 22.3002 5.58456C22.2205 5.89095 22.0757 6.17673 21.8756 6.42259C21.5248 6.83612 20.7793 7.25195 20.1793 7.58738L19.8793 7.73441C19.1385 7.02451 18.6077 6.44327 18.6031 6.43867C18.383 6.18414 18.2274 5.88077 18.1494 5.55401C18.0715 5.22725 18.0734 4.88663 18.155 4.56076C18.2366 4.23488 18.3955 3.93325 18.6185 3.68117C18.8414 3.42909 19.1218 3.23391 19.4362 3.11203C19.7289 2.98696 20.0471 2.93218 20.365 2.95214C20.6829 2.97209 20.9917 3.06622 21.2663 3.2269C21.5356 3.37341 21.7704 3.57544 21.9551 3.81948C22.1398 4.06353 22.27 4.34396 22.3371 4.6421V4.6467ZM19.5354 18.4082C19.0436 18.4148 18.5564 18.3123 18.1093 18.108C17.6622 17.9037 17.2664 17.6029 16.9507 17.2273C15.8106 15.8305 16.0507 13.8134 17.4723 12.5774C18.0948 12.0723 18.7648 11.6284 19.4731 11.2517L23.9364 15.6582C22.7317 17.4708 21.2455 18.4036 19.5354 18.4036V18.4082Z"
            fill="#00263E"
          />
          <path
            d="M11.7075 1.03516H0.0876906C0.0648264 1.03515 0.0428627 1.04403 0.0264811 1.05991C0.0100996 1.07578 0.000601687 1.09741 0 1.12016V20.3403C0 20.3634 0.00923901 20.3856 0.0256853 20.402C0.0421316 20.4184 0.064432 20.4276 0.0876906 20.4276H2.69781C2.72107 20.4276 2.74338 20.4184 2.75983 20.402C2.77627 20.3856 2.78551 20.3634 2.78551 20.3403V12.7267H10.5374C10.5603 12.7267 10.5822 12.7178 10.5986 12.7019C10.615 12.686 10.6245 12.6644 10.6251 12.6417V10.0433C10.6251 10.0201 10.6159 9.99793 10.5994 9.98155C10.583 9.96518 10.5607 9.95599 10.5374 9.95599H2.78551V3.80813H11.7075C11.7307 3.80813 11.753 3.79892 11.7695 3.78255C11.7859 3.76618 11.7952 3.74398 11.7952 3.72083V1.12016C11.7946 1.09741 11.7851 1.07578 11.7687 1.05991C11.7523 1.04403 11.7303 1.03515 11.7075 1.03516V1.03516Z"
            fill="#00263E"
          />
          <path
            d="M45.2973 1.03516H33.6775C33.6547 1.03515 33.6327 1.04403 33.6163 1.05991C33.6 1.07578 33.5904 1.09741 33.5898 1.12016V20.3403C33.5898 20.3634 33.5991 20.3856 33.6155 20.402C33.632 20.4184 33.6543 20.4276 33.6775 20.4276H36.2969C36.3202 20.4276 36.3425 20.4184 36.3589 20.402C36.3754 20.3856 36.3846 20.3634 36.3846 20.3403V12.7267H44.1342C44.1571 12.7267 44.179 12.7178 44.1954 12.7019C44.2118 12.686 44.2213 12.6644 44.2219 12.6417V10.0433C44.2219 10.0201 44.2127 9.99793 44.1962 9.98155C44.1798 9.96518 44.1575 9.95599 44.1342 9.95599H36.3754V3.80813H45.2973C45.3206 3.80813 45.3429 3.79892 45.3593 3.78255C45.3758 3.76618 45.385 3.74398 45.385 3.72083V1.12016C45.3844 1.09741 45.3749 1.07578 45.3585 1.05991C45.3422 1.04403 45.3202 1.03515 45.2973 1.03516V1.03516Z"
            fill="#00263E"
          />
        </>
      );
      break;

    case 'mega-menu':
      data = (
        <>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect x="0" y="0" width="24" height="24"></rect>
            <rect
              fill="#000000"
              x="4"
              y="5"
              width="16"
              height="3"
              rx="1.5"
            ></rect>
            <path
              d="M5.5,15 L18.5,15 C19.3284271,15 20,15.6715729 20,16.5 C20,17.3284271 19.3284271,18 18.5,18 L5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 Z M5.5,10 L18.5,10 C19.3284271,10 20,10.6715729 20,11.5 C20,12.3284271 19.3284271,13 18.5,13 L5.5,13 C4.67157288,13 4,12.3284271 4,11.5 C4,10.6715729 4.67157288,10 5.5,10 Z"
              fill="#000000"
              opacity="0.3"
            ></path>
          </g>
        </>
      );
      break;

    case 'mega-close':
      data = (
        <>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
              fill="#000000"
            >
              <rect x="0" y="7" width="16" height="2" rx="1"></rect>
              <rect
                opacity="0.3"
                transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
                x="0"
                y="7"
                width="16"
                height="2"
                rx="1"
              ></rect>
            </g>
          </g>
        </>
      );
      break;

    case 'group':
      data = (
        <>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <polygon points="0 0 24 0 24 24 0 24"></polygon>
            <path
              d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.3"
            ></path>
            <path
              d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
              fill="#000000"
              fillRule="nonzero"
            ></path>
          </g>
        </>
      );
      break;
    case 'dot':
      data = (
        <>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <polygon points="0 0 24 0 24 24 0 24"></polygon>
            <path
              d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.3"
            ></path>
            <path
              d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
              fill="#000000"
              fillRule="nonzero"
            ></path>
          </g>
        </>
      );
      break;
    case 'search2':
      data = (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.6131 13.0576C20.6131 15.144 19.7674 17.0329 18.4001 18.4002C17.0327 19.7675 15.1438 20.6132 13.0574 20.6132C8.8845 20.6132 5.50171 17.2305 5.50171 13.0576C5.50171 8.88473 8.8845 5.50195 13.0574 5.50195C17.2303 5.50195 20.6131 8.88473 20.6131 13.0576Z"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.5017 22.502L18.3992 18.3994"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      );
      break;
    case 'edit':
      data = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.86133 15.4875L15.083 15.4875"
            stroke="#0066CC"
            strokeLinecap="round"
          />
          <path
            d="M15.1775 7.05926L7.74266 14.4941L4.55749 14.9007L4.97343 11.7249L12.4083 4.29002L15.1775 7.05926Z"
            stroke="#0066CC"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'edit2':
      data = (
        <>
          <path
            d="M11.7988 18.3203H17.7988"
            stroke="white"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path
            d="M17.9074 8.63559L9.36434 17.1786L5.70442 17.6458L6.18236 13.9966L14.7254 5.45361L17.9074 8.63559Z"
            stroke="white"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
      break;
    case 'arrowUp3':
      data = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 2L8 15"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 8L8 1L1 8"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'x':
      data = (
        <>
          <path
            d="M24 8.37109L8 24.3711"
            stroke="#888D96"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.00012 8.37109L24.0001 24.3711"
            stroke="#888D96"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
      break;
    case 'empty':
      data = (
        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.7925 8.5V11.0849"
            stroke="#E7E9EC"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5001 9L15.7925 11.2386"
            stroke="#E7E9EC"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.085 9L25.7926 11.2386"
            stroke="#E7E9EC"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.30005 23.0705H15.3484C15.3679 24.0692 15.9946 26.0666 18.3444 26.0666C20.6943 26.0666 22.8484 26.0666 23.6316 26.0666C24.3758 25.7728 25.864 24.7624 25.864 23.0705H33.7948M7.30005 23.0705V32H33.7948V23.0705M7.30005 23.0705L12.9985 17.9008H27.9202L33.7948 23.0705"
            stroke="#E7E9EC"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'comment2':
      data = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M14 7H5.81397C5.59809 7 5.39105 7.08576 5.23841 7.23842C5.08576 7.39107 5 7.59811 5 7.814V15.954C5 16.1699 5.08576 16.3769 5.23841 16.5296C5.39105 16.6822 5.59809 16.768 5.81397 16.768H9.38293V19.21L13.4528 16.768H16.7086C16.9245 16.768 17.1315 16.6822 17.2842 16.5296C17.4368 16.3769 17.5226 16.1699 17.5226 15.954L17.5226 13.5"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.0002 7.38452L15.6718 12.7129L13.1884 12.8036L13.2871 10.3282L18.6155 4.9998L21.0002 7.38452Z"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'refresh':
      data = (
        <>
          <path
            d="M8 3.25C10.6234 3.25 12.75 5.37665 12.75 8C12.75 10.6234 10.6234 12.75 8 12.75C5.37665 12.75 3.25 10.6234 3.25 8C3.25 6.50783 3.93805 5.17637 5.01418 4.30556"
            stroke="#888D96"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.25 4.0415H5.36111V6.15261"
            stroke="#888D96"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
      break;
    case 'back': {
      data = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M2.00001 9L17.1667 9"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 0.833344L0.833336 9.00001L9 17.1667"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    }
    case 'rightArrow': {
      data = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M8.33334 5.83334L12.5 10L8.33334 14.1667"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    }
    default:
      data = <></>;
      break;
  }
  return (
    <svg
      className={className}
      xmlns={xmlns}
      style={style}
      width={`${width}px` || 'current'}
      height={`${height}px` || 'current'}
      viewBox={viewBox || 'current'}
      version={version}
      fill={fill}
    >
      {data}
    </svg>
  );
}
